import { useCallback, useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getOpenDockWarehouseDetails } from '../../use-cases/getOpenDockWarehouseDetails'

export function useGetOpenDockWarehouseDetails(
  shipmentUUID: string,
  stopIndex: number,
  enabled: boolean
) {
  const { call, result, status, error } = useAsync(getOpenDockWarehouseDetails)
  const abortController = useAbortController()

  const fetchOpenDockWarehouseDetails = useCallback(
    (shipmentUUID: string, stopIndex: number) =>
      call({
        shipmentUUID,
        stopIndex,
        config: abortController,
      }),
    [abortController, call]
  )

  useEffect(() => {
    if (enabled) {
      fetchOpenDockWarehouseDetails(shipmentUUID, stopIndex)
    }
  }, [enabled, fetchOpenDockWarehouseDetails, shipmentUUID, stopIndex])

  return {
    warehouseDetails: result,
    status,
    error,
    fetchOpenDockWarehouseDetails,
  }
}
